export var POST_EXCERPT_MAX_LENGTH = 480;
